/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();



function toggleIT(textbv){
  var item = document.querySelector('.ymq_titleCurrent');
  if(!item)return;
  item.innerHTML = textbv;
}
function setBack(){
  var item = document.querySelector('.ymq_titleCurrent');
  if(!item)return;
  item.innerHTML = item.dataset.default;
}
